<template>
  <footer class="main_footer">
    <span class="main_footer_ver">
      {{ translate('ver') }}: {{ version }}
    </span>
    <span class="main_footer_copy copyright_sis"> &copy; <a
      :href=$root.attribute.company_url
      target="_blank"
    >{{$root.attribute.name_company}}</a> {{ year }}
    </span>

    <div class="main_footer_lang">
      <a
        v-for="(ln, key) in ['ru','en']"
        :key="key"
        class="main_footer_lang_point"
        :class="(lang === ln)? 'main_footer_lang_point--active' : ''"
        @click="toggleLang(ln)"
      >{{ ln }}</a>
    </div>
  </footer>
</template>
<script>
export default {
  data () {
    return {
      lang: this.localStorage.getItem('vue-lang')
    }
  },
  computed: {
    year () {
      return new Date().getFullYear()
    },
    version(){
      return this.$store.getters.getVersionMonitoringFront
    }
  },
  watch: {
    lang () { this.language = this.lang }
  },
  methods: {
    toggleLang (lang) {
      this.lang = lang
      this.localStorage.setItem('vue-lang', lang)
    }
  }
}
</script>
<style lang="scss" scoped>
  .main_footer{
    &_ver{
      color: #66615b;
      font: 12px/15px "Roboto", Arial, sans-serif;
      margin-right: 5px;
    }
  }

</style>
